import { Icon } from './types';

export const BriefCase = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 34 34"
    fill="none"
    data-testid="brief-case"
    {...svgProps}
  >
    <path
      fill="currentColor"
      d="M5.667 31.167c-.78 0-1.445-.284-1.998-.836-.552-.553-.836-1.218-.836-1.998V12.75c0-.78.284-1.445.836-1.998.553-.552 1.219-.835 1.998-.835h5.667V7.083c0-.779.283-1.445.835-1.997.553-.553 1.219-.836 1.998-.836h5.667c.779 0 1.445.283 1.997.836.553.552.836 1.218.836 1.997v2.834h5.666c.78 0 1.446.283 1.998.835.553.553.836 1.219.836 1.998v15.583c0 .78-.284 1.445-.836 1.998-.552.552-1.218.836-1.997.836H5.666Zm8.5-21.25h5.667V7.083h-5.667v2.834Zm14.167 12.75H21.25V25.5h-8.5v-2.833H5.667v5.666h22.666v-5.666Zm-12.75 0h2.833v-2.834h-2.834v2.834Zm-9.917-2.834h7.083V17h8.5v2.833h7.084V12.75H5.666v7.083Z"
      {...pathProps}
    />
  </svg>
);
